'use strict';

import jQuery from 'jquery';

var MobilePersistentAd = (function($) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      adUnit: '',
      defaults: { // Namespace for default options
      },
      adSettings: {}
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function init() {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // Attach event handlers
      privateNS.attachHandlers();

      privateNS.adUnit = privateNS.$container.find('.googletag-ad').data('unit');

      try {
        privateNS.adSettings = JSON.parse(window.localStorage.getItem('ad-settings')) || {};
      } catch (e) {}

      if (typeof privateNS.adSettings[privateNS.adUnit] === 'undefined' ||
          privateNS.adSettings[privateNS.adUnit].display === true ||
          privateNS.adSettings[privateNS.adUnit].expires < Math.floor(Date.now() / 1000)) {
        privateNS.$container.removeClass('hide');
      }

      // Return the public namespace
      return publicNS;
    };

    /**
     * Toggles an ad to its hidden state and installs a cookie to prevent it
     * from showing in the future
     */
    publicNS.hideAd = function hideAd() {
      privateNS.adSettings[privateNS.adUnit] = {
        display: false,
        expires: Math.floor(Date.now() / 1000) + 30 * 24 * 60 * 60
      };

      window.localStorage.setItem('ad-settings', JSON.stringify(privateNS.adSettings));

      // Hide the ad on the page
      privateNS.$container.addClass('hide');
    };

    /**
     * Attach the event handlers for the header triggers
     */
    privateNS.attachHandlers = function attachHandlers() {

      // Attach an event to the mobile persistent close button
      privateNS.$container.on(
        'click',
        '.mobile-persistent-close-button',
        publicNS.hideAd
      );
    };

    // Return a new instance
    return privateNS.init();
  };
})(jQuery);

export default MobilePersistentAd